import React, {Component} from 'react';
import './Industries.css';
import IndustriesCard from './IndustriesCard.js'
import agritech from '../../../images/pplogo-192-agritech.png';
import capital from '../../../images/pplogo-192-capital.png';
import energy from '../../../images/pplogo-192-energy.png';
import medical from '../../../images/pplogo-192-health.png';
import realestate from '../../../images/pplogo-192-realestate.png';
import agritechTitle from '../../../images/maintitle/agritechMainTitle.jpg';
import energyTitle from '../../../images/maintitle/energyMainTitle.jpg';
import medicalTitle from '../../../images/maintitle/medicalMainTitle.jpg';
import realestateTitle from '../../../images/maintitle/realEstateMainTitle.jpg';



export default class Industries extends Component {

	render() {

		return (
			<div className="industries_container" id="industries_container">
				<div className="industries_title">
					<span>OUR INDUSTRIES</span>
				</div>
				<div className="industries_description">
					<span>PPI continues to look at new opportunities that are a strategic fit into our existing business from the following sectors:</span>
				</div>
				<div className="industries_content">
					<IndustriesCard image={realestateTitle} logo={realestate} industry="REAL ESTATE" link='/realestate'/>
					<IndustriesCard image={agritechTitle} logo={agritech} industry="AGRICULTURE & AGRITECH" link='/agriculture' />
					<IndustriesCard image={medicalTitle} logo={medical} industry="HEALTHCARE" link='/healthcare' />
					<IndustriesCard image={energyTitle} logo={energy} industry="ENERGY, OIL & GAS" link='energy' />


				</div>
				<div className="industries_content_desktop">
					<div className="row">
					<IndustriesCard image={realestateTitle} logo={realestate} industry="REAL ESTATE" link='/realestate'/>
					<IndustriesCard image={agritechTitle} logo={agritech} industry="AGRICULTURE & AGRITECH" link='/agriculture' />

					</div>
					<div className="row">
					<IndustriesCard image={medicalTitle} logo={medical} industry="HEALTHCARE" link='/healthcare' />
					<IndustriesCard image={energyTitle} logo={energy} industry="ENERGY, OIL & GAS" link='/energy' />
					</div>
				</div>
			</div>
		)
	}
};
